/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  subject,
  templateParams,
  isVoiceMessage = false,
  emailHtmlContent,
  forwardedAttachmentIds,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (subject) {
      payload.append('subject', subject);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    if (isVoiceMessage) {
      payload.append('is_voice_message', true);
    }
    if (emailHtmlContent) {
      payload.append('email_html_content', emailHtmlContent);
    }
    forwardedAttachmentIds?.forEach(id => {
      payload.append('forwarded_attachment_ids[]', id);
    });
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      subject,
      template_params: templateParams,
      email_html_content: emailHtmlContent,
      forwarded_attachment_ids: forwardedAttachmentIds,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    subject,
    templateParams,
    isVoiceMessage = false,
    emailHtmlContent,
    forwardedAttachmentIds,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        subject,
        templateParams,
        isVoiceMessage,
        emailHtmlContent,
        forwardedAttachmentIds,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  clear(conversationId) {
    return axios.delete(`${this.url}/${conversationId}/messages/clear`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getMessage({ conversationId, messageId }) {
    return axios.get(`${this.url}/${conversationId}/messages/${messageId}`);
  }

  getPreviousMessages({ conversationId, after, before, beforeCreatedAt }) {
    const params = {};
    const hasBefore = before !== undefined && before !== null;
    if (hasBefore) {
      params.before = before;
    }
    if (beforeCreatedAt !== undefined && beforeCreatedAt !== null) {
      params.before_created_at = beforeCreatedAt;
    }
    if (
      after !== undefined &&
      after !== null &&
      (!hasBefore || Number(after) !== Number(before))
    ) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }
}

export default new MessageApi();
